
















































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import layout from '@/libs/layout/school/equipment';
import { modifyActivation, getActivationbindList } from '@/api/school';
@Component({
  components: {
    manageDialog: () => import('./manage-dialog.vue')
  },
  filters: {
    getStatus(value: any) {
      let statusObj = {
        'OFF': 'info', // 未激活
        'ON': 'success', // 使用中
        'CLOSED': 'warning', // 已作废
        'EXPIRDE': 'danger' // 已过期
      }
      return (statusObj as any)[value]
    }
  }
})
export default class List extends Vue {
  @Prop({
    type: Object,
    default() {
      return {
        totalPage: 1,
        currentPage: 1,
        pageSize: 20,
        list: []
      };
    }
  })
  page!: Object;

  @Prop({
    type: Function,
    default() {
      return function() {};
    }
  })
  handleOptions!: Function;

  @Prop({
    type: Function,
    default() {
      return function() {};
    }
  })
  getData!: Function;

  private layout: any = layout
  private bindList: any = []
  // 设备管理
  private manage(row: any) {
    let opt = { activationId: row.id, isBind: 'ON' }
    this.getBindList(opt);
    (this.$refs.manageDailog as any).dialogVisible  = true
  }
  // 重置
  private resetCode(row: any) {
    if (row.activationStatus === 'CLASSING') {
      this.$message.error('该激活码正在上课中，不允许重置操作！')
      return
    }
    this.$confirm("确定重置该激活码吗?", "确认", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true
      }).then(async () => {
          try {
            let opt = { activationId: row.id, modifyType: 2 }
            await modifyActivation(opt);
            await this.getData();
            this.$message.success('重置激活码成功');
          } catch (err) {
              this.$message.error(err.message);
          }
        })
          .catch(err => {})
  }
  // 获取设备绑定列表
  private async getBindList(opt: any) {
    try {
      this.bindList = await getActivationbindList(opt)
    } catch (err) {
      this.$message.error(err.message)
    }
  }
  private handlePage(page: number) {
    this.handleOptions({ currentPage: page });
    this.getData();
  }
  private handleSize(size: number) {
    this.handleOptions({ pageSize: size });
    this.getData();
  }
}
